import { Container } from "./styles";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Container>
      <h1>
        © {currentYear} Susana Natividade
        <br />
        All Rights Reserved
      </h1>

      <div className="separator"></div>
    </Container>
  );
}
